import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=31499711&scoped=true&"
import script from "./SectionCard.vue?vue&type=script&lang=js&"
export * from "./SectionCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=31499711&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31499711",
  null
  
)

export default component.exports